export const EXAM_TYPES = Object.freeze({
    GMAT: 'gmat',
    GRE: 'gre',
    IELTS: 'ielts',
    TOEFL: 'toefl'
});

export const SUBJECT_TITLES = Object.freeze({
    QUANT: 'Quantitative',
    VERBAL: 'Verbal'
});

export const SIGNUP_PLATFORMS = Object.freeze({
    YOCKET: 1,
    SUPERTEST: 2
});

export const SUBJECTS = Object.freeze({
    QUANT: 'quant',
    VERBAL: 'verbal',
    DATA_INSIGHTS: 'dataInsights'
});
